import React, { useState } from 'react';

const guias = [
  {
    id: 'activacion_sim',
    icon: '📱',
    titulo: 'Activar una SIM física',
    pasos: [
      'Ve a la sección "Activación" en tu panel.',
      'Ingresa el IMEI del dispositivo del cliente (marca *#06# en el teléfono) o usa la cámara 📷 para capturarlo.',
      'Ingresa el ICCID de la tarjeta SIM o escanéalo con la cámara.',
      'El sistema validará que el ICCID esté en estatus "Idle" (disponible).',
      'Selecciona la oferta que el cliente desea.',
      'Si el cliente quiere portar su número, activa la casilla de Portabilidad e ingresa el número y NIP (marca 051 desde la línea a portar).',
      'Presiona "Activar". Si tu saldo alcanza se descuenta automáticamente, si no se genera un pago con Clip.',
      'Después de la activación, el cliente debe registrar su IMEI en rnu.altanredes.com.',
    ],
  },
  {
    id: 'activacion_esim',
    icon: '📧',
    titulo: 'Vender una eSIM Nacional',
    pasos: [
      'Dirígete a "Compra de Esim Monkey" en el menú principal.',
      'El cliente debe buscar su modelo de dispositivo para verificar compatibilidad.',
      'Selecciona el dispositivo de la lista.',
      'Ingresa el correo electrónico del cliente (ahí recibirá el QR de la eSIM).',
      'Si el cliente quiere portar su número, activa la opción e ingresa NIP y número.',
      'Presiona "Continuar con la compra" y selecciona la oferta.',
      'Se genera el pago. Si estás logueado como vendedor, tu ID se envía automáticamente.',
      'El cliente recibirá el QR por correo para instalar la eSIM.',
    ],
  },
  {
    id: 'esim_internacional',
    icon: '✈️',
    titulo: 'Vender una eSIM Internacional',
    pasos: [
      'Ve a "Compra de Esim Internacional" en el menú.',
      'El cliente verifica que su dispositivo sea compatible.',
      'Revisa las ofertas disponibles con cobertura en 200+ países.',
      'El cliente selecciona el plan que necesita para su viaje.',
      'Ingresa el correo del cliente y si tiene un código promocional.',
      'Presiona "Comprar ahora" para generar el pago.',
      'La eSIM se envía al correo del cliente lista para instalar.',
    ],
  },
  {
    id: 'recarga',
    icon: '💰',
    titulo: 'Hacer una Recarga',
    pasos: [
      'Ve a "Recarga y Consulta Saldo" en el menú principal.',
      'Ingresa el número de 10 dígitos del cliente y presiona "Consultar".',
      'Verás el estatus de la línea, consumo actual y fecha de vencimiento.',
      'Selecciona la oferta que el cliente desea de la lista.',
      'Si tienes saldo de vendedor y quieres usarlo, activa el toggle de saldo.',
      'Presiona "Comprar". Si usas tu saldo se descuenta, si no se genera pago con Clip.',
      'La recarga se aplica en unos minutos.',
    ],
  },
  {
    id: 'compra_saldo',
    icon: '💳',
    titulo: 'Comprar Saldo de Vendedor',
    pasos: [
      'En tu panel, presiona "Comprar Saldo".',
      'Ingresa el monto que deseas comprar (mínimo $500, máximo $25,000).',
      'Presiona "Comprar Saldo" para generar el pago con Clip.',
      'Una vez completado el pago, tu saldo se acredita automáticamente.',
      'Con saldo puedes activar líneas y hacer recargas sin pasar por Clip cada vez.',
    ],
  },
  {
    id: 'reportes',
    icon: '📊',
    titulo: 'Ver tus Reportes de Ventas',
    pasos: [
      'En tu panel, presiona "Reportes".',
      'Verás todas tus transacciones con folio, fecha, estatus y oferta.',
      'Usa el filtro de mes para ver un periodo específico.',
      'Presiona "CSV" para descargar tu reporte en Excel.',
      'Toca cualquier transacción para ver detalles como ICCID y SKU.',
    ],
  },
  {
    id: 'saldo',
    icon: '🏦',
    titulo: 'Consultar tu Saldo',
    pasos: [
      'En tu panel, presiona "Saldo".',
      'Verás tu saldo disponible en la tarjeta principal.',
      'Desde ahí puedes ir directo a Reportes o Activar Línea.',
      'Tu saldo se descuenta automáticamente cuando activas líneas o haces recargas con el toggle activado.',
    ],
  },
  {
    id: 'grupo',
    icon: '👨‍👩‍👧‍👦',
    titulo: 'Crear un Grupo Familiar/Empresa',
    pasos: [
      'Ve a "Mi Grupo" en el menú principal.',
      'Ingresa el número administrador del grupo.',
      'Agrega las líneas del grupo con un alias para identificarlas.',
      'Podrás ver el consumo de todas las líneas en una sola página.',
      'Usa el botón "Recargar" en cada línea para ir directo a la recarga.',
    ],
  },
  {
    id: 'referidos',
    icon: '🤝',
    titulo: 'Invitar Referidos',
    pasos: [
      'Ve a "Invita a un amigo" en el menú.',
      'Llena los datos de quien refiere (tú o tu cliente) y del referido.',
      'Al enviar, quien refiere se registra como vendedor automáticamente.',
      'Recibirá un correo con sus credenciales de acceso.',
      'El referido será contactado por el equipo MonkeyPhone.',
    ],
  },
];

export default function Glosario() {
  const [abierto, setAbierto] = useState(null);

  return (
    <div style={{ marginTop: 20 }}>
      <h2 style={{ color: '#1a3a2a', marginBottom: 4 }}>📖 Guía del Vendedor</h2>
      <p style={{ color: '#6b8f71', fontSize: 13, marginBottom: 20 }}>
        Aprende paso a paso cómo realizar cada operación.
      </p>

      {guias.map((g) => (
        <div
          key={g.id}
          style={{
            background: '#fff',
            borderRadius: 14,
            marginBottom: 10,
            border: abierto === g.id ? '2px solid #2d6a4f' : '1px solid #d4e8d6',
            overflow: 'hidden',
            transition: 'border 0.2s',
          }}
        >
          <button
            onClick={() => setAbierto(abierto === g.id ? null : g.id)}
            style={{
              width: '100%',
              padding: '14px 16px',
              background: abierto === g.id ? '#e0f2e5' : '#fff',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              fontSize: 14,
              fontWeight: 600,
              color: '#1a3a2a',
              textAlign: 'left',
            }}
          >
            <span>
              <span style={{ marginRight: 8 }}>{g.icon}</span>
              {g.titulo}
            </span>
            <span style={{ fontSize: 18, color: '#6b8f71' }}>
              {abierto === g.id ? '▲' : '▼'}
            </span>
          </button>

          {abierto === g.id && (
            <div style={{ padding: '12px 16px 16px' }}>
              {g.pasos.map((paso, i) => (
                <div
                  key={i}
                  style={{
                    display: 'flex',
                    gap: 10,
                    marginBottom: 10,
                    fontSize: 13,
                    color: '#333',
                    lineHeight: 1.5,
                  }}
                >
                  <span
                    style={{
                      flexShrink: 0,
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      background: '#2d6a4f',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 12,
                      fontWeight: 700,
                    }}
                  >
                    {i + 1}
                  </span>
                  <span style={{ paddingTop: 2 }}>{paso}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      <div style={{ height: 80 }} />
    </div>
  );
}
